/**
 * English copy catalog for the `community` feature (forums, threads, Hall of
 * Legends). Keys mirror the `t('community.*')` calls in
 * packages/@gamecodex/world-ui/src/features/community.
 */
export const communityJa = {
  // CommunityPage
  'community.page.seoTitle': 'コミュニティ',
  'community.page.seoDescription':
    'Grymwyrдコミュニティに参加しよう：フォーラム、世界観考察、GMツール、ホームブルー、そして「伝説の殿堂」。',
  'community.page.eyebrow': '集いし暗き者たち',
  'community.page.title': 'コミュニティ',
  'community.page.intro':
    '戦術を交わし、考察を紡ぎ、ホームブルーを共有し、正史へと昇りつめよ。投稿するたびに、永劫の薄暮のなかでコインと名声を獲得できます。',
  'community.page.loading': '信者たちを集めている…',
  'community.page.forumCategories': 'フォーラムカテゴリー',
  'community.page.categoryStats': '{threads}個のスレッド · {posts}個の投稿',
  'community.page.recentActivity': '最近の活動',
  'community.page.liveFeed': 'ライブフィード',
  'community.page.recentEmpty':
    '今夜、フォーラムは静寂に包まれています。議論を始めて死者を目覚めさせましょう。',
  'community.page.hallOfLegends': '伝説の殿堂',
  'community.page.hallBlurb': '最高の貢献者たちと、彼らが正史へと鍛え上げたキャラクター。',
  'community.page.enterTheHall': '殿堂に入る',
  'community.page.playerSpotlights': 'プレイヤースポットライト',
  'community.page.summoningLegends': '伝説を召喚中…',
  'community.page.sampleNotice': 'ライブフォーラムが目覚めている間、サンプルコミュニティコンテンツを表示しています。',

  // FlagButton
  'community.flag.errorQueued':
    'モデレーターに今すぐ連絡することはできませんでしたが、あなたの報告はキューに入っています。',
  'community.flag.ariaLabel': 'この投稿をモデレーション対象にフラグを立てる',
  'community.flag.label': 'フラグ',
  'community.flag.modalTitle': 'キーパーズへの報告',
  'community.flag.successDelivered':
    'あなたの報告はモデレーターに届きました。キーパーズはあなたに感謝します。',
  'community.flag.close': '閉じる',
  'community.flag.signInNotice':
    ' 問題を説明することはできますが、報告をモデレーターに届けるにはサインインする必要があります。',
  'community.flag.whyFlagging': 'なぜこの投稿にフラグを立てますか？',
  'community.flag.reason.spamOrAdvertising': 'スパムまたは広告',
  'community.flag.reason.harassmentOrAbuse': 'ハラスメントまたは悪用',
  'community.flag.reason.spoilersWithoutWarning': '警告なしのネタバレ',
  'community.flag.reason.offTopic': 'スレッド外',
  'community.flag.reason.otherDescribeBelow': 'その他（以下で説明）',
  'community.flag.describeIssue': '問題を説明する',
  'community.flag.detailPlaceholder': 'キーパーズに何が間違っているかを説明してください…',
  'community.flag.cancel': 'キャンセル',
  'community.flag.reporting': '報告中…',
  'community.flag.submitReport': 'レポートを送信',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — フォーラム',
  'community.category.seoDescription': 'Grymwyrdの{name}フォーラムでの議論。',
  'community.category.breadcrumb': 'コミュニティ',
  'community.category.entityTiedPrefix': 'エンティティ連動掲示板 · スレッドは次のものにリンクされる場合があります',
  'community.category.encyclopediaEntries': '百科事典エントリー',
  'community.category.sampleNotice': 'ライブフォーラムが目覚めている間、サンプルスレッドを表示しています。',

  // HallOfLegendsPage
  'community.legends.seoTitle': '伝説の殿堂',
  'community.legends.seoDescription':
    'Grymwyrдへの最高の貢献者たちと、彼らが正史へと鍛え上げたキャラクター。',
  'community.legends.breadcrumb': 'コミュニティ',
  'community.legends.title': '伝説の殿堂',
  'community.legends.intro':
    'ここに永劫の薄暮の建築者たちが立っている。言葉が法となった貢献者たちであり、そしてあまりに愛されて正史に刻み込まれたキャラクターたち。',
  'community.legends.loading': 'ろうそくに火をつけている…',
  'community.legends.topContributors': 'トップコントリビューター',
  'community.legends.noContributors':
    'まだ伝説は生まれていません。投稿し、考察し、創造して、あなたの場所を掴み取りましょう。',
  'community.legends.canonizedCharacters': '正史化されたキャラクター',
  'community.legends.noCharacters':
    'まだ正史化されたキャラクターはいません。モンストロジアはその次の恐怖を待っています。',
  'community.legends.sampleNotice': 'ライブホールが祝別されている間、サンプル伝説を表示しています。',

  // NestedReplies
  'community.replies.replyBy': '{author}からの返信',
  'community.replies.reply': '返信',
  'community.replies.replyToPlaceholder': '{author}に返信…',
  'community.replies.unlike': 'この投稿をいいねを取り消す',
  'community.replies.like': 'この投稿をいいねする',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} rep',
  'community.spotlight.viewInEncyclopedia': '百科事典で{name}を表示',

  // PostComposer
  'community.composer.placeholder': '暗き声を足す…',
  'community.composer.signInPrompt': 'サインインして議論に参加し、あなたの言葉でコインを獲得しましょう。',
  'community.composer.signInToReply': 'サインインして返信',
  'community.composer.youFallback': 'あなた',
  'community.composer.saveError':
    'あなたの返信をサーバーに保存できませんでした。ローカルでのみ表示されています。',
  'community.composer.writeReply': '返信を書く',
  'community.composer.writePost': '投稿を書く',
  'community.composer.replyText': '返信のテキスト',
  'community.composer.postText': '投稿のテキスト',
  'community.composer.posting': '投稿中…',
  'community.composer.postReply': '返信を投稿',
  'community.composer.post': '投稿',
  'community.composer.cancel': 'キャンセル',
  'community.composer.coinsPerPost': '投稿あたり+{count}コイン',
  'community.composer.coinsEarned': 'あなたの投稿で+{count}コイン獲得！',

  // ThreadItem
  'community.thread.pinned': 'ピン留めスレッド',
  'community.thread.byPrefix': '投稿者',
  'community.thread.repliesTitle': '{count}個の返信',
  'community.thread.likesTitle': '{count}個のいいね',
  'community.thread.viewsTitle': '{count}回閲覧',
  'community.thread.entityEntry': '{type}エントリー',

  // ThreadList
  'community.threadList.empty':
    'ここではまだ何の議論も起きていません。最初に沈黙を破りましょう。',

  // ThreadPage
  'community.threadPage.loading': 'スレッドを解封している…',
  'community.threadPage.seoDescription': 'Grymwyrдコミュニティフォーラムの議論。',
  'community.threadPage.replyCount': '{count}個の返信',
  'community.threadPage.opened': '{time}に開かれた',
  'community.threadPage.entityEntry': '{type}エントリー',
  'community.threadPage.sampleNotice': 'ライブフォーラムが目覚めている間、サンプル議論を表示しています。',
  'community.threadPage.openingPostBy': '{author}による最初の投稿',
  'community.threadPage.repliesHeading': '返信',
  'community.threadPage.noReplies': 'まだ返信がありません。最初に応じましょう。',
  'community.threadPage.addYourReply': 'あなたの返信を追加',
} as const
